<template>
  <layout-guest >
    <main
     
      class="container-wrap-base"
    >
      <v-container class="py-8">
        <v-row>
          <v-col>
            <h1 class="conf py-5">
              {{ $t("supplierData.confirmacionDatosExistente") }}
            </h1>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="12" lg="12">
            <label class="second-type-label">{{ $t("supplierData.razonSocial") }}</label> <br />
            <h2 class="fur">
             {{ supplierName.supplierName }} 
            </h2>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="3" lg="3">
            <label class="second-type-label">{{ $t("supplierData.nombre") }}</label> <br />
            <h2 class="text-h6 font-weight-light">
              {{ model.alias }}
            </h2>
          </v-col>

          <v-col cols="12" md="3" lg="3">
            <label class="second-type-label">{{ $t("supplierData.email") }}</label> <br />
            <h2 class="text-h6 font-weight-light">
              {{ model.email }}
            </h2>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="12" lg="12">
            <h2 class="text-h6 font-weight-light" v-if="!hiddenCheck">
             {{ $t("supplierData.esNecesario") }} 
            </h2>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="12" lg="5">
            <checkbox-terms :checkboxData="entityConfig.checkboxConfirmCreateUser" @accepted="checkbox = true" @canceled="checkbox = false" />
          </v-col>
        </v-row>

        <v-flex xs12 offset-xs6>
          <v-row class="pb-5">
            <v-col cols="12" sm="12" lg="12">
              <v-btn
                v-if="!confirmed"
                depressed
                :color="entityConfig.primaryColor"
                :style="`color: ${entityConfig.secondaryColor}`"
                class="float-end m-2 v-btn-width-default"
                v-on:click="onComplete()"
                :disabled="!checkbox"
              >
                {{ $t("supplierData.confirmar") }}
              </v-btn>
              <v-btn
                v-else
                depressed
                :color="entityConfig.primaryColor"
                :style="`color: ${entityConfig.secondaryColor}`"
                class="float-end m-2 v-btn-width-default"
                v-on:click="finalizar"
                :disabled="!checkbox"
              >
                {{ $t("supplierData.finish") }}
              </v-btn>

              <v-btn
                v-if="!confirmed"
                outlined                
                v-on:click="volver()"
                :color="entityConfig.primaryColor"
                class="float-end m-2 v-btn-width-default"
              >
                {{ $t("supplierData.volver") }}
              </v-btn>
              <v-btn
                v-else
                plain
                @click="print()"                
                :color="entityConfig.primaryColor"
                class="float-end m-2"
              >
                <v-icon :color="entityConfig.primaryColor" left>
                  mdi-printer-outline
                </v-icon>
                {{ $t("supplierData.print") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-container>
      <overlay :visible="spinner" :opacity="1"></overlay>
      <confirm-dialog
        :visible="confirmDialog"
        @closed="confirmDialog = !confirmDialog; goToLogin();"
      ></confirm-dialog>
    </main>
  </layout-guest>
</template>

<script>
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
import ConfirmDialog from "./confirm_crreate.vue";
import CheckboxTerms from "../../components/layouts/checkbox-terms.vue";
import LayoutGuest from "../../components/layouts/layout-guest.vue";
import { mapState } from "vuex";

export default {
  components: {
    ConfirmDialog,
    Overlay,
    "layout-guest": LayoutGuest,
    "checkbox-terms": CheckboxTerms
  },
  data() {
    return {
      supplierName:'',
      respuestaData: "",
      entityConfig: {},
      confirmed: false,
      hiddenCheck: false,
      confirmDialog: false,
      loginUrl: "/",
      spinner: false,
      checkbox: false,
      form: {
        alias: "",
        codNrbeEn: "",
        email: "",
        languageCode: "ES",
        phone: "",
        principalUser: true,
        supplierId: "",
        password: "",
      },
      model: {
        alias: "",
        codNrbeEn: "",
        email: "",
        languageCode: "ES",
        phone: "",
        principalUser: true,
        supplierId: "",
        password: "",
      },
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    this.codNrbeEn = sessionStorage.getItem("codNrbeEn");
    this.supplierName = JSON.parse(sessionStorage.getItem("supplierName"));
    let newAccesData = JSON.parse(sessionStorage.getItem("accesDataConfirm"));
    this.hiddenCheck = this.entityConfig.checkboxConfirmCreateUser?.type == 'hidden';
    if (newAccesData) {
      this.model = newAccesData;
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
    } else {
      this.$router.go(-1);
    }
  },

  computed: {
    ...mapState("accessData", [
      "alias",
      "phone",
      "email",
      "languageCode",
      "password",
      "languageCode",
      "principalUser",
      "password",
    ]),
    ...mapState("companyData", ["supplierId", "token"]),
  },

  methods: {
    initializarVistaConBotonBack() {
      this.form = JSON.parse(sessionStorage.getItem("formAnticitpo"));
    },

    print() {
      window.print();
    },
    volver() {
      this.$router.push({
        path: "/access-data",
        query: { goBack: true },
      });
    },
    goHome() {
      this.$router.push({ path: "/" });
    },

    onComplete(){
      this.spinner = true;
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("token");
        this.model.supplierId = this.supplierId;
        let objCopy = Object.assign({}, this.model);

        if (this.model.phone == "") {
          delete objCopy.phone;
        }

        Api.post("/usuarios", objCopy).then((response) => {
        this.respuestaData = response.data.message;
        sessionStorage.removeItem("accesDataConfirm");
        sessionStorage.removeItem("supplierId");
        sessionStorage.removeItem("token");
        this.spinner = false;
        this.confirmed = true;
        if (this.respuestaData == "Created only email") {
            this.$toast.success(this.$t("users.createdMessageExistenteSinConfirmar"));
          } else {
            this.$toast.success(this.$t("users.createdMessage"));
          }
        }).catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },

    finalizar() {
      this.confirmDialog = true;      
    },
    goToLogin() {
      this.$router.push("/");
    }
  },
};
</script>
